// src/components/common/Unauthorized.jsx
import React from 'react';
import { Typography, Container, Button, Box } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import ReportProblemIcon from '@mui/icons-material/ReportProblem'; // Ícono opcional

const Unauthorized = () => {
  const location = useLocation();
  // Recupera la ruta a la que se intentó acceder (si se pasó en el estado de la navegación)
  const attemptedPath = location.state?.attemptedPath;

  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', mt: '20vh' }}>
      <Box sx={{ mb: 2 }}>
        <ReportProblemIcon color="error" sx={{ fontSize: 60 }} />
      </Box>
      <Typography variant="h4" component="h1" gutterBottom color="error">
        Acceso Denegado
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Lo sentimos, no tienes los permisos necesarios para acceder a esta sección
        {attemptedPath && ` (${attemptedPath})`}.
        Si crees que esto es un error, por favor contacta al administrador.
      </Typography>
      <Button
        component={RouterLink}
        to="/dashboard" // Enlace para volver a una página segura
        variant="contained"
        color="primary"
      >
        Volver al Inicio
      </Button>
    </Container>
  );
};

export default Unauthorized;